module.exports = __webpack_public_path__ + "static/media/facebook-empty.a93c796a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/facebook-empty.svg
// module id = 170
// module chunks = 0